

export const frontMatter = {
	slug: 'dockview-1.4.3-release',
	title: 'Dockview 1.4.3',
	tags: [
		'release'
	]
};
export const contentTitle = 'Release Notes';
export const metadata = {
  "permalink": "/blog/dockview-1.4.3-release",
  "source": "@site/blog/2022-05-26-dockview-1.4.3.mdx",
  "title": "Dockview 1.4.3",
  "description": "🚀 Features",
  "date": "2022-05-26T00:00:00.000Z",
  "formattedDate": "May 26, 2022",
  "tags": [
    {
      "label": "release",
      "permalink": "/blog/tags/release"
    }
  ],
  "readingTime": 0.515,
  "hasTruncateMarker": false,
  "authors": [],
  "frontMatter": {
    "slug": "dockview-1.4.3-release",
    "title": "Dockview 1.4.3",
    "tags": [
      "release"
    ]
  },
  "unlisted": false,
  "prevItem": {
    "title": "Dockview 1.5.0",
    "permalink": "/blog/dockview-1.5.0-release"
  },
  "nextItem": {
    "title": "Dockview 1.4.2",
    "permalink": "/blog/dockview-1.4.2-release"
  }
};
export const assets = {
"authorsImageUrls": [],
};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "🚀 Features",
  "id": "-features",
  "level": 2
}, {
  "value": "🛠 Miscs",
  "id": "-miscs",
  "level": 2
}, {
  "value": "🔥 Breaking changes",
  "id": "-breaking-changes",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "-features",
      children: "🚀 Features"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Small adjusted to behaviours of default paneview header componnet ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/116",
          children: "#116"
        }), " ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/120",
          children: "#120"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Improved support for external dnd events in the dockview component. ", _jsx(_components.code, {
          children: "showDndOverlay"
        }), " prop on ", _jsx(_components.code, {
          children: "DockviewReact"
        }), " exposes more parameters to interact with ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/110",
          children: "#110"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Improved to underlying events exposes through all components ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/114",
          children: "#114"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Add .clear() to the component APIs providing an easy way to clear a layout ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/119",
          children: "#119"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Udate orientation via componnet APIs is now working correctly ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/119",
          children: "#119"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-miscs",
      children: "🛠 Miscs"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Documentation enhancements ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/101",
          children: "#101"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Move documentation to ", _jsx(_components.a, {
          href: "https://dockview.dev",
          children: "dockview.dev"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-breaking-changes",
      children: "🔥 Breaking changes"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Fix typo by renaming ", _jsx(_components.code, {
          children: "onDidLayoutfromJSON"
        }), " to ", _jsx(_components.code, {
          children: "onDidLayoutFromJSON"
        }), " in dockview component api ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/112/files",
          children: "#112"
        })]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

